import apiCalls from '../../config/apiCalls';
import Utility from '../../helpers/utility';
import headers from '../../config/headers';
import get from 'lodash/get';
import { IS_INDIA } from '../../helpers/paymentConstants';
import LocalStorageFunc from "../../helpers/localStorageFunc";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY
} from "../../config/vwoKeys";
import PageNames from "../../config/pageNames";

export default {
  namespaced: true,
  state: {
    copyOfferCodeOnApply: true,
    vwoExperiments: {
      [VWO_NEXTGEN_HOMEPAGE_EXPERIMENT]: ''
    },
    appConfig: {},
    pwaConfig: {},
    isStatic: true,
    placeHolderImg: {square : '' , rect : ''},
    dot20ModalFlag: false,
  },
  getters: {
    getVwoExperiments: (state) => {
      return state.vwoExperiments;
    },
    getPwaConfig: (state) => {
      return state.pwaConfig;
    },
    getAppConfig: (state) => {
      return state.appConfig;
    },
    getCurrentStoreFolderFromConfig: (state) => {
      let _ = window._siteProps_?.link_rewrite;
      let noRedirect = Utility.getNoRedirectFromWindow();
      
      if(
        _ === PageNames.NEXTGEN_LINKREWRITE_HOME && 
        noRedirect
      ) {
        return `/${PageNames.NEXTGEN_LINKREWRITE_HOME}/`;
      }
    
      if(
        LocalStorageFunc.getSessionStorageKey('previousLinkRewrite') === PageNames.NEXTGEN_LINKREWRITE_HOME && 
        noRedirect
      ) {
        return '/menu/';
      }
      
      if (_ == "/") {
        _ = "";
      }

      switch (state.vwoExperiments?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT]) {
        case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_N:
          return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_N}/`;
        case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_O:
          return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_O}/`;
        case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_P:
          return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_P}/`;
        case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S:
          return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_S}/`;
        case VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL:
          return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.CONTROL}/`;
        case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U: {
          if(_ === 'menu')
            return '/menu/';
          return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_U}/`;
        }
        case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W: {
          if(_ === 'menu')
            return '/menu/';
          return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_W}/`;
        }
        case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X: {
          if(_ === 'menu')
            return '/menu/';
          return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_X}/`;
        }
        case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y: {
          if(_ === 'menu')
            return '/menu/';
          return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_Y}/`;
        }
        default:
          return `/${"store" || _}/`;
      }
    },
    getPlaceHolderImage: (state) => {
      return state.placeHolderImg;
    },
  },
  mutations: {
    updateVwoExperiments(state, payload) {
      state.vwoExperiments = payload;
    },
    updateAppConfig(state, payload) {
      state.appConfig = {
        timeLastStored: new Date().getTime(),
        config: payload,
      }
    },
    updatePwaConfig(state, payload) {
      state.pwaConfig = payload
    },
    updatePlaceHolderImage: (state, payload) => {
      state.placeHolderImg = payload;
    },
    updateDot20ModalFlag: (state, payload) => {
      state.dot20ModalFlag = payload;
    },
  },
  actions: {
    getPWAConfig({ commit, state, dispathc }, payload) {
      try {
        const vendor = Utility.getMiniAppStorageVal();
        const currentEnv = API_END_POINT || 'local';
        const clientId = currentEnv === 'production' ? 'merchant-dominos-pizza-prod' : 'merchant-dominos-pizza-uat';
        apiCalls.GET_PWA_CONFIG({
          headers: headers(),
          payload: {}
        })
          .then((res) => {
            if (res?.data) {
              let response = res.data;
              if (response.disableCookies) {
                LocalStorageFunc.setLocalStorageValue('disableCookies', true);
              }

              // START : Hardcoding config values for PAYTM here to solve issue ( login not happening for new users 1st time entering the miniapp - its happening 2nd time onwards in their journey)
              if (vendor === 'PAYTM') {
                response.vendorConfig = {
                  PAYTM: {
                    partnerName: 'paytm',
                    primaryPaymentId: 'PAYTMMP_CC',
                    clientId,
                    source: 'Paytm-microapp'
                  },
                  blockedFeatures: [
                    'irctc',
                    'feedback',
                    'deals_and_offer',
                    'deliver_on_train',
                    'wallet',
                    'support',
                    'logout',
                    'offers',
                    'showAppBanner',
                    'everyday_value_offer',
                    'edv'
                  ]
                };
              }
              // END : Hardcoding config values for PAYTM here to solve issue

              if (response.vendorConfig && vendor !== 'PAYTM') {
                response.vendorConfig = JSON.parse(response.vendorConfig);
                // response.vendorConfig[vendor].clientId = clientId; // this will happen in case of PAYTM only
              }

              if (vendor) {
                const featuresData = JSON.parse(response.features || '{}');
                const vendorBlockedFeatures = get(
                  response,
                  `vendorConfig.blockedFeatures`,
                  []
                );
                for (let idx = 0; idx < featuresData.features.length; idx++) {
                  if (vendorBlockedFeatures.indexOf(featuresData.features[idx]) !== -1) {
                    featuresData.features.splice(idx, 1);
                  }
                }
                response.features = JSON.stringify(featuresData);
              }
              commit("updatePwaConfig", response);
            }
          })
          .catch((error) => {
            console.error('Get PWA config Error...', error);
          });
      } catch (error) {
        console.error('ERROR: getConfigSaga', error.message);
      }
    },
    getAppConfig({ commit, state, dispatch }, payload) {
      try {
        apiCalls.GET_APP_CONFIG({
          headers: headers(),
          payload: {}
        }).then((res) => {
          if (res?.data) {
            let response = res.data;
            commit("updateAppConfig", response);
            state.isStatic = false;
            const isMiniApp = ['true', true].includes(Utility.checkIfIsMiniApp());
            localStorage.isDefaultWalletApplied = IS_INDIA && response.isDefaultWalletApplied;
            const storageIsWalletUsed = [
              'undefined',
              'null',
              undefined,
              null,
              'true',
              true
            ].includes(localStorage.isWalletUsed);

            const isWalletUsed =
              IS_INDIA && storageIsWalletUsed
                ? isMiniApp
                  ? false
                  : response.isDefaultWalletApplied
                : storageIsWalletUsed;
            LocalStorageFunc.setLocalStorageValue('isWalletUsed', isWalletUsed);
          }
        }).catch((error) => {
          console.error('Get APP config Error...', error);
        });
      } catch (error) {
        console.error('ERROR in getAppConfigSaga', error);
      }
    }
  },
};
